module.exports = __webpack_public_path__ + "static/media/36.b8d34f61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/36.jpg
// module id = 211
// module chunks = 0